module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toch"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#int",
      "id": "rint"
    }
  }, [_vm._v("Introduction: The Shaken and the Stirred (Stephen Schneider and Craig N. Owens)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Part01#pt1",
      "id": "rpt1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 1")]), _vm._v(": "), _c('i', [_vm._v("Muddled Mythologies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#ch1",
      "id": "rch1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("“The greatest of all the contributions of the American way of life to the salvation of humanity”: On the Prehistory of the American Cocktail (Jonathan Elmer)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter02#ch2",
      "id": "rch2"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("The Boulevardier: Craft, Industrialism, and the Nostalgic Origin in Cocktail Culture (Antonio Ceraso)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#ch3",
      "id": "rch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("A Continued Stream of Fire: Professor Jerry Thomas Invents the “Blue Blazer” (Christoph Irmscher)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#ch4",
      "id": "rch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("The Sazerac Mixing Ritual: Storytelling, Parody, and New Orleans (Joseph Turner)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter05#ch5",
      "id": "rch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("My First Time (Albert W. A. Schmid)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part02#pt2",
      "id": "rpt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 2:")]), _vm._v(" "), _c('i', [_vm._v("Spirits of the Age")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter06#ch6",
      "id": "rch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("“They made me feel civilized”: The Martini as Modernist Culture (Michael Coyle)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter07#ch7",
      "id": "rch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("At Home with Postwar Cocktail Culture and the Cocktail Dress (Lori Hall-Araujo)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter08#ch8",
      "id": "rch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Middlebrow Cosmopolitanism and the Canadian Cocktail (Lisa Sumner)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter09#ch9",
      "id": "rch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Absolut Psychosis (Craig N. Owens)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter10#ch10",
      "id": "rch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "spacen"
  }, [_vm._v("Joy Perrine and the Bourbon Cocktail’s Renaissance (Susan Reigler)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part03#pt3",
      "id": "rpt3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 3:")]), _vm._v(" "), _c('i', [_vm._v("Mixed Messages")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter11#ch11",
      "id": "rch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "spacen"
  }, [_vm._v("Inventing Margarita: Femininity, Fantasy, and Consumption (Marie Sarita Gaytán)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter12#ch12",
      "id": "rch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "spacen"
  }, [_vm._v("Polynesian Paralysis: Tiki Culture and the Aesthetics of American Empire (Andrew Pilsch)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter13#ch13",
      "id": "rch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "spacen"
  }, [_vm._v("The Irish Car Bomb (and One Other Disreputable “Cocktail”) (Stephen Watt)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter14#ch14",
      "id": "rch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14."), _c('span', {
    staticClass: "spacen"
  }, [_vm._v("Bar Trek (William Biferie)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter15#ch15",
      "id": "rch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15."), _c('span', {
    staticClass: "spacen"
  }, [_vm._v("The Taming of the Shrub (Dan Callaway)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part04#pt4",
      "id": "rpt4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 4:")]), _vm._v(" "), _c('i', [_vm._v("In a Glass, Darkly")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter16#ch16",
      "id": "rch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16."), _c('span', {
    staticClass: "spacen"
  }, [_vm._v("The Lingering Louche: Absinthe, the Green Demon of Alternative Modernity (Aaron Jaffe)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter17#ch17",
      "id": "rch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17."), _c('span', {
    staticClass: "spacen"
  }, [_vm._v("Rye Take on the Past—The Old-Fashioned Cocktail: A Glass of Crooning Sophistication (Judith Roof)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter18#ch18",
      "id": "rch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18."), _c('span', {
    staticClass: "spacen"
  }, [_vm._v("The Manhattan (Edward P. Comentale)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter19#ch19",
      "id": "rch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19."), _c('span', {
    staticClass: "spacen"
  }, [_vm._v("Cocktails That Aren’t Cocktails for Gentlemen Who Aren’t Men: Recovering the Metaphorical Body of the Fictional Drinker (Michael Jay Lewis)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter20#ch20",
      "id": "rch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20."), _c('span', {
    staticClass: "spacen"
  }, [_vm._v("The Cold Gray Dawn of the Morning After: Hangover Cures and the Inevitability of Excess (Stephen Schneider)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Afterword#aft",
      "id": "raft",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword: Confessions of a Cocktail Nerd (Sonja Kassebaum)")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Contributors#con",
      "id": "rcon",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Index#ind",
      "id": "rind",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18c47215","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 72
// module chunks = 0